// extracted by mini-css-extract-plugin
export default {"sortInfo":"sortInfo__NDMwZ","sortInfoTooltip":"sortInfoTooltip__NGFkN"};